module.exports = __webpack_public_path__ + "img/shutterstock_2057993291.b8f2f057.svg";